import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-c07-tv-intro-screen',
  templateUrl: './c07-tv-intro-screen.component.html',
  styleUrls: ['./c07-tv-intro-screen.component.scss'],
})
export class C07TvIntroScreenComponent {
  public imageLinks = [
    {
      dataAnimation: 'fundation',
      class: 'background',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/fundation-background.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/fundation-background.jpg`,
    },
    {
      dataAnimation: 'fundation',
      class: 'header',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-fundation-copy.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-fundation-copy.png`,
    },
    {
      dataAnimation: 'intro',
      class: 'background',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/browse-titles-intro-bg.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/browse-titles-intro-bg.jpg`,
    },
    {
      dataAnimation: 'intro-header-menu',
      class: 'header',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-menu.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-menu.png`,
    },
    {
      dataAnimation: 'intro-header-profile',
      class: 'header',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-profile.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-profile.png`,
    },
    {
      dataAnimation: 'intro-copy',
      class: 'header',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-copy.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-copy.png`,
    },
    {
      dataAnimation: 'apps',
      class: 'header apps',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-apps.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-apps.png`,
    },
    {
      dataAnimation: 'apps-highlighted',
      class: 'header apps-highlighted',
      webpSrc: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-apps-highlighted.webp`,
      src: `${environment.baseHref}/assets/images/browse-titles-page/intro-header-apps-highlighted.png`,
    },
  ];
}
